export default __webpack_public_path__ + "static/2-bdea805d340832e0bf7df822c9af3191.jpeg";